export default __webpack_public_path__ + "static/media/not-found.748f9d4d.svg";